import { render, staticRenderFns } from "./datasetmodal.vue?vue&type=template&id=11da475c&scoped=true"
import script from "./datasetmodal.vue?vue&type=script&lang=js"
export * from "./datasetmodal.vue?vue&type=script&lang=js"
import style0 from "./datasetmodal.vue?vue&type=style&index=0&id=11da475c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da475c",
  null
  
)

export default component.exports